const HouseGridSelectorShowing = {
	Entries:'entries',
	Info:'info'
};
HouseGridSelectorShowing.getClassName=function(value){
	return `showing-${value}`;
};
export default HouseGridSelectorShowing;